import { Title } from '../../components/Title';
import { ContentScreen } from '../../styles/ContentScreen';
import iosShare from './ios-share.png';
import iosHome from './ios-home.png';
import androidMenu from './android-menu.png';
import androidHome from './android-home.png';

const GetApp = () => (
   <ContentScreen className="narrower">
      <Title
         title="Get the App"
         description="Instructions for how you can get an app-like experience on mobile when using Ear Instructor."
      />
      <article>
         <h1>Get the App</h1>
         <p>
            The Ear Instructor website is designed to offer an app-like
            experience on mobile. Just follow the instructions below, no
            download required.
         </p>
         <h2 style={{ marginTop: '2em' }}>Android</h2>
         <h3 style={{ marginTop: '2em' }}>Step 1</h3>
         <p>
            If you are viewing this on your mobile device, proceed to step 2,
            otherwise open{' '}
            <a href="https://earinstructor.com" className="link">
               earinstructor.com
            </a>{' '}
            on your device.
         </p>
         <h3 style={{ marginTop: '2em' }}>Step 2</h3>
         <img
            src={androidMenu}
            style={{ width: '100%', marginBottom: '1em' }}
            alt="android browser controls with menu button highlighted"
         />
         <p>Open the browser menu by tapping on the three dots icon.</p>
         <h3 style={{ marginTop: '2em' }}>Step 3</h3>
         <img
            src={androidHome}
            style={{ width: '100%', marginBottom: '1em' }}
            alt={`android browser menu with "Add to Home Screen" highlighted`}
         />
         <p>Select "Add to Home Screen".</p>
         <h2 style={{ marginTop: '2em' }}>iOS</h2>
         <h3 style={{ marginTop: '2em' }}>Step 1</h3>
         <p>
            If you are viewing this on your mobile device, proceed to step 2,
            otherwise open{' '}
            <a href="https://earinstructor.com" className="link">
               earinstructor.com
            </a>{' '}
            on your device.
         </p>
         <h3 style={{ marginTop: '2em' }}>Step 2</h3>
         <img
            src={iosShare}
            style={{ width: '100%', marginBottom: '1em' }}
            alt="ios safari's browser controls with share button highlighted"
         />
         <p>Tap the share option in the browser controls.</p>
         <h3 style={{ marginTop: '2em' }}>Step 3</h3>
         <img
            src={iosHome}
            style={{ width: '100%', marginBottom: '1em' }}
            alt={`ios safari share options with "Add to Home Screen" highlighted`}
         />
         <p>
            Select "Add to Home Screen". You may have to scroll down to see this
            option.
         </p>
      </article>
   </ContentScreen>
);

export { GetApp };
